import { createRadioOptionsHook } from "../hooks/create-radio-options-hook.js";
import { CaptionsRadioGroupCore } from "@videojs/core";
import { selectTextTrack } from "@videojs/core/dom";
//#region src/ui/captions-radio-group/use-captions-options.ts
const useCaptionsRadioOptions = createRadioOptionsHook({
	name: "useCaptionsOptions",
	feature: "textTrack",
	selector: selectTextTrack,
	createCore: () => new CaptionsRadioGroupCore()
});
/**
* Create captions menu options (including an `Off` option) from the player text track state. Returns `null` when the
* text tracks feature is not configured.
*
* @param props - Optional `label`, `formatTrack`, and `disabled` overrides.
*/
function useCaptionsOptions(props) {
	"use no memo";
	const result = useCaptionsRadioOptions(props);
	if (!result) return null;
	return {
		...result,
		showMenu: result.state.options.length > 2
	};
}
//#endregion
export { useCaptionsOptions };

//# sourceMappingURL=use-captions-options.js.map